import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSportConfig } from '../context/SportConfig';
import useMdEntries from '../hooks/useMdEntries';
import '../styles/InfoPages.css';

function Faq() {
  const { entries, loading, error } = useMdEntries('faq.md');
  const [openIdx, setOpenIdx] = useState(null);
  const sportConfig = useSportConfig();
  const navTitle = sportConfig ? `${sportConfig.appEmoji} ${sportConfig.appName}` : '…';

  const toggle = (i) => setOpenIdx(openIdx === i ? null : i);

  return (
    <>
      <Helmet>
        <title>FAQ — Fantastic Tennis Fantasy League</title>
        <meta name="description" content="Frequently asked questions about Fantastic Tennis. Learn how Hero Mode, snake draft, open draft, scoring, budget drafting, and league management work in our free fantasy tennis platform." />
        <link rel="canonical" href="https://tennis.playfantastic.net/faq" />
      </Helmet>
    <div className="info-page">
      <nav className="info-page-nav">
        <div className="nav-left">
          <Link to="/" className="nav-title-link">
            <h1 className="nav-title">{navTitle}</h1>
          </Link>
        </div>
        <div className="nav-right">
          <Link to="/news" className="btn btn-secondary">News</Link>
          <Link to="/login" className="btn btn-secondary">Login</Link>
          <Link to="/signup" className="btn btn-primary">Sign Up</Link>
        </div>
      </nav>

      <div className="info-page-content">
        <header className="info-page-header">
          <h2>❓ Frequently Asked Questions</h2>
          <p>Everything you need to know about {sportConfig?.appName || 'Fantastic Tennis'}</p>
        </header>

        {loading && <p className="info-page-loading">Loading FAQ...</p>}
        {error && <p className="info-page-error">{error}</p>}

        {!loading && !error && (
          <div className="faq-accordion">
            {entries.map((entry, i) => (
              <div
                key={i}
                className={`faq-item${openIdx === i ? ' open' : ''}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggle(i)}
                  aria-expanded={openIdx === i}
                >
                  <span>{entry.title}</span>
                  <span className="faq-chevron">{openIdx === i ? '▲' : '▼'}</span>
                </button>
                {openIdx === i && (
                  <div className="faq-answer">
                    <p>{entry.body}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="info-page-back">
          <Link to="/" className="btn btn-secondary">← Back to Home</Link>
          <Link to="/news" className="btn btn-secondary">See News →</Link>
        </div>

        <div className="faq-contact">
          <p>Still have questions? Email us at <a href="mailto:support@playfantastic.net">support@playfantastic.net</a></p>
        </div>
      </div>
    </div>
    </>
  );
}

export default Faq;
